import { Component, OnInit,HostListener } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  query,
  stagger,
  animateChild,
  group,
  sequence,
  keyframes,
  // ...
} from '@angular/animations';
import { Subscription } from 'rxjs';

import {DisplayUserActionService} from "../display-user-action.service"


@Component({
  selector: 'app-service-select-mobile',
  animations: [
    trigger('service-toggle', [
      state('closed', style({ width:'40px' })),
      state('open', style({ width:'55vw' })),
      transition('closed <=> open', [
        animate('1s')
      ])
    ]),


    trigger('service-clem-list', [
      transition(':enter', [
        query('@service-items', stagger(100, animateChild())),
      ]),
    ]),
    trigger('service-items', [
      transition(':enter', [
        style({ transform: 'scale(0.5)', opacity: 0 }),  // initial
        animate('1s cubic-bezier(.8, -0.6, 0.2, 1.5)', 
          style({ transform: 'scale(1)', opacity: 1 }))  // final
      ]),
      transition(':leave', [
        style({ transform: 'scale(1)', opacity: 1 }),  // initial
        animate('1s cubic-bezier(.8, -0.6, 0.2, 1.5)', 
          style({ transform: 'scale(0.5)', opacity: 0 }))  // final
      ])
    ]),
  ],
      // transition('open => close', [
      //   animate('1s cubic-bezier(.8, -0.6, 0.2, 1.5)', 
      // ])
  templateUrl: './service-select-mobile.component.html',
  styleUrls: ['./service-select-mobile.component.scss']
})


export class ServiceSelectMobileComponent implements OnInit {
  counter = 5;
  seletedService;
  serviceList = [];
  list = [];
  public isMobileDivice; 

  setDevice() {
    if (this.innerWidth <= 768) {
      this.isMobileDivice = false;
      return;
    }
    this.isMobileDivice =  true;
  }

  private countdownEndRef: Subscription = null;
  constructor(private displayUserActionService :DisplayUserActionService) {
   }
   public innerWidth: any;
  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.setDevice();
    this.serviceList  = this.displayUserActionService.getOfflineServiceList();
    this.seletedService = this.serviceList[0];

    this.countdownEndRef = this.displayUserActionService.countdownEnd$.subscribe((value)=>{
      this.serviceList  = this.displayUserActionService.getnNewSelected(value);
      this.seletedService = value;
    });
  }

  isOpen = false;
  sidenav;
  remove(index) {    
    if(!this.list.length) return false;
    this.list.splice(index, 1);
    return true;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.setDevice();

  }

  clearAll() {
    this.list = [];
    // let list = this.list;
    // let interval = setInterval(function(){
    //    if(!list.length)  clearInterval(interval);
    //    list.splice(0, 1);
          
    // }, 100); // every 100 milliseconds
  }


  toggle(id) {
   this.serviceList  = this.displayUserActionService.getnNewSelected(id);
    if (!this.list.length) {
      this.list = this.displayUserActionService.getOfflineServiceList();
      this.isOpen = true;
    }
    else {
      this.clearAll();
      this.isOpen = false;
    }
  }
}
